import { createFileRoute } from '@tanstack/react-router';

import { ExerciseLibraryScreen, validateExerciseLibrarySearch } from '~/pages/exercise-library';

export const Route = createFileRoute('/_shell/cwiczenia')({
  // Which parameters this screen understands is the SLICE's decision, so the validator is exported
  // from it: a route file is a wiring declaration, and anything a second route could want does not
  // live here. Today that is `?zakres=biblioteka|twoje` — no parameter means all three lists — and
  // `?cwiczenie=<id>`, the one movement whose card is open over the table.
  validateSearch: validateExerciseLibrarySearch,
  component: ExerciseLibraryScreen,
});
